import { createAsyncThunk } from '@reduxjs/toolkit'
import { AppThunkAction } from 'redux/store'
import {
  GetDemographicInfoRequest,
  GetDemographicInfoResponse
} from 'services/demographics/typings'
import { updateLoginInfoState } from 'redux/loginInfo/loginInfoSlice'
import { ServerError } from 'typings/serverError'
import demographicsAPI from 'services/demographics'
import { updateDemographicInfoState } from './demographicSlice'

const onSuccess =
  (
    response: GetDemographicInfoResponse,
    payload: GetDemographicInfoRequest
  ): AppThunkAction =>
  dispatch => {
    const { isResetPasswordFlow } = payload
    const {
      acctDemographicInfo: { demographics = [] }
    } = response

    const [accountInfo] = demographics
    const { relationship } = accountInfo || {}

    dispatch(
      updateDemographicInfoState({
        demographyInfo: demographics,
        isResponseFail: false,
        errorMessage: ''
      })
    )

    if (isResetPasswordFlow) {
      dispatch(
        updateLoginInfoState({ accountIndicator: relationship.slice(0, 1) })
      )
    }
  }

const onFailure =
  (errorResponse: ServerError): AppThunkAction =>
  dispatch => {
    const { response } = errorResponse
    const { message } = response || {}

    dispatch(
      updateDemographicInfoState({
        demographyInfo: [],
        isResponseFail: true,
        errorMessage: message
      })
    )
  }

export const getDemographicInfo = createAsyncThunk(
  'demographicSlice/getDemographicInfo',
  async (payload: GetDemographicInfoRequest, { dispatch }) => {
    try {
      const response = await demographicsAPI.getDemographicInfo(payload)
      dispatch(onSuccess(response, payload))
    } catch (error) {
      dispatch(onFailure(error as ServerError))
    }
  }
)

export const getDemographicChildInfo = createAsyncThunk(
  'demographicSlice/getDemographicChildInfo',
  async (payload: GetDemographicInfoRequest, { dispatch }) => {
    try {
      const response = await demographicsAPI.getDemographicChildInfo(payload)
      dispatch(onSuccess(response, payload))
    } catch (error) {
      dispatch(onFailure(error as ServerError))
    }
  }
)
